import { useGetBlogProductMutation } from '@/shared/api-rtk/index.js'
import { useEffect, useState } from 'react'
import { TOAST_ERROR } from '@/shared/constants/toastTypes.js'
import { useCutLengthText } from '@/shared/hooks/useCutLengthText.js'
import BlogItem from '@/entities/BlogItem/index.js'

export const BlogChapter = ({ productId }) => {
    const [blog, setBlog] = useState([])
    const [countShowPosts, setCountShowPosts] = useState(4)
    const [getBlogPosts] = useGetBlogProductMutation()

    const limitPosts = countShowPosts >= blog.length

    useEffect(() => {
        getBlogPosts(productId)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setBlog(Object.values(res.data))
                } else {
                    setBlog([])
                }
            })
    }, [])

    if (!blog) {
        return <h4>Загрузка...</h4>
    }

    let position_big = 0

    return (
        <div className={'BlogChapter'}>
            {!!blog.length && (
                <div className={'posts'}>
                    {blog
                        ?.slice(0, countShowPosts)
                        .map(
                            (
                                { image, title, description, blog_id, url },
                                index
                            ) => {
                                const cutText = useCutLengthText(
                                    String(description),
                                    50
                                )
                                if (url) {
                                    position_big = position_big + 1
                                    if (position_big > 4) position_big = 1

                                    if (
                                        position_big == 1 ||
                                        position_big == 4
                                    ) {
                                        return (
                                            <BlogItem
                                                key={image}
                                                text={cutText}
                                                title={title}
                                                image={image}
                                                itemId={blog_id}
                                                itemUrl={url}
                                                itemClass={'item-long'}
                                            />
                                        )
                                    } else {
                                        return (
                                            <BlogItem
                                                key={image}
                                                text={cutText}
                                                title={title}
                                                image={image}
                                                itemId={blog_id}
                                                itemUrl={url}
                                                itemClass={'item-short'}
                                            />
                                        )
                                    }
                                }
                            }
                        )}

                    {!limitPosts && (
                        <div className={'action'}>
                            <button
                                onClick={() =>
                                    setCountShowPosts((state) => state + 4)
                                }
                            >
                                <img
                                    src="/icons/showMore.svg"
                                    alt="Иконка загрузки новых вопросов"
                                />
                                <span>Показать ещё</span>
                            </button>
                        </div>
                    )}
                </div>
            )}
            {!blog.length && <div>По данному товару нет блогов.</div>}
        </div>
    )
}
